export default {
  links: [
    {
      name: 'About',
      href: '#about'
    },
    {
      name: 'Products',
      href: '#products'
    },
    {
      name: 'Press',
      href: '#press'
    },
    {
      name: 'Contact',
      href: '#contact'
    }
  ],
}



// WEBPACK FOOTER //
// ./client/store/imports/HeaderLinks.js